<template lang="pug">
v-dialog(v-model="searchCar" id="carModal" width="80%" :fullscreen="$vuetify.breakpoint.xsOnly" persistent)
  v-form
    v-card(:height="modalHeightDynamic")
      v-card-title.headline.grey.lighten-2 Search Kendaraan
      v-card-text
        v-container()
          v-layout(row wrap)
            v-flex(xs8 sm8)
              br
              v-text-field(label="Masukan Plat Nomor/Merk/Model/Jenis Kendaraan/Equipment Supplier", required, v-model="searchQuery", @keyup.enter="search" :rules="rules")
            v-flex(xs4 sm4)
              br
              br
              v-btn(color="blue darken-1", text, bottom, @click="search") Search
            v-flex(xs12 sm12)
              v-data-table(:headers="tableData.headers" :items="tableData.items" show-select v-model="selectedCars")
                  template(v-slot:item.actions="{ item }")
                      v-chip(label small color="green" style="width:100%;justify-content:space-evenly" @click="selectCars()" text-color="white") Select
      v-card-actions
        v-spacer
        v-btn(color="blue darken-1", text, @click="closingModal") Close
        v-btn(color="blue darken-1", text, @click="selectCars()") Select
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SearchCarInfo",
  components: {},
  props: {
    searchCar: Boolean,
  },
  mounted() {
    this.modalHeightDynamic = false;
  },
  data() {
    return {
      searchQuery: "",
      idCard: "",
      department: "",
      modalHeight: '',
      selectedCars: [],

      tableData: {
        headers: [
          { text: 'Plat Nomor', value: 'no_lambung' },
          { text: 'Merk', value: 'merk' },
          { text: 'Model', value: 'series' },
          { text: 'Jenis Kendaraan', value: 'type'},
          {text : 'Equipment supplier', value:'equipment_supplier'},
        ],
        items: []
      },

      // uploadBukti2: false,
      closing: false,
      docPelaporan: null,
      rules: [
        (value) =>
        (value && value.length >= 3) || 'Min 3 characters' || !this.searchBTn.input-value
      ],
      emptyUpload: new File([""], "", {
        type: "",
      }),
    };
  },
  computed: {
    ...mapState(["API_URL", "dataUsers", "searchCarInfo", "filteredCarInfos"]),
    modalHeightDynamic: {
      get() {
        return this.modalHeight;
      },
      set(val) {
        const delta = this.dynamicHeight(val);
        this.modalHeight = delta;
      }
    }
  },
  methods: {
    dynamicHeight: function (search) {
      const isMobile = this.$vuetify.breakpoint.xsOnly;
      const mobileHeight = this.$vuetify.breakpoint.height;
      if(search) {
        if(this.tableData.items.length < 3) {
          return mobileHeight;
        } 
        return '';
      }
      if(isMobile) {
        return `${mobileHeight}`;
      }
      return '';
    },
    search() {
      if(this.searchQuery.length>=3){
        this.$store
          .dispatch("searchCarInfo", {
            query: this.searchQuery,
          })
          .then(() => {
            if (this.filteredCarInfos.length < 1) {
              alert("No Data Found");
              this.tableData.items = [];
            }else {
              this.tableData.items = this.filteredCarInfos;
              this.modalHeightDynamic = true;
            }
          });
      }
    },
    selectCars() {
        this.$emit('selectedCars', this.selectedCars);
        this.closingModal();
    },
    closingModal: function () {
      this.$emit('interface', false)
    },
  },
  watch: {},
};
</script>

<style scoped>
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 11.3cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
</style>